import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// @ts-check
import { WalkerBase } from './walker.js';
/** @typedef { import('estree').BaseNode} BaseNode */

/** @typedef { import('./walker.js').WalkerContext} WalkerContext */

/** @typedef {(
 *    this: WalkerContext,
 *    node: BaseNode,
 *    parent: BaseNode,
 *    key: string,
 *    index: number
 * ) => void} SyncHandler */

export var SyncWalker = /*#__PURE__*/function (_WalkerBase) {
  _inherits(SyncWalker, _WalkerBase);

  var _super = _createSuper(SyncWalker);

  /**
   *
   * @param {SyncHandler} enter
   * @param {SyncHandler} leave
   */
  function SyncWalker(enter, leave) {
    var _this;

    _classCallCheck(this, SyncWalker);

    _this = _super.call(this);
    /** @type {SyncHandler} */

    _this.enter = enter;
    /** @type {SyncHandler} */

    _this.leave = leave;
    return _this;
  }
  /**
   *
   * @param {BaseNode} node
   * @param {BaseNode} parent
   * @param {string} [prop]
   * @param {number} [index]
   * @returns {BaseNode}
   */


  _createClass(SyncWalker, [{
    key: "visit",
    value: function visit(node, parent, prop, index) {
      if (node) {
        if (this.enter) {
          var _should_skip = this.should_skip;
          var _should_remove = this.should_remove;
          var _replacement = this.replacement;
          this.should_skip = false;
          this.should_remove = false;
          this.replacement = null;
          this.enter.call(this.context, node, parent, prop, index);

          if (this.replacement) {
            node = this.replacement;
            this.replace(parent, prop, index, node);
          }

          if (this.should_remove) {
            this.remove(parent, prop, index);
          }

          var skipped = this.should_skip;
          var removed = this.should_remove;
          this.should_skip = _should_skip;
          this.should_remove = _should_remove;
          this.replacement = _replacement;
          if (skipped) return node;
          if (removed) return null;
        }

        for (var key in node) {
          var value = node[key];

          if (typeof value !== "object") {
            continue;
          } else if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i += 1) {
              if (value[i] !== null && typeof value[i].type === 'string') {
                if (!this.visit(value[i], node, key, i)) {
                  // removed
                  i--;
                }
              }
            }
          } else if (value !== null && typeof value.type === "string") {
            this.visit(value, node, key, null);
          }
        }

        if (this.leave) {
          var _replacement2 = this.replacement;
          var _should_remove2 = this.should_remove;
          this.replacement = null;
          this.should_remove = false;
          this.leave.call(this.context, node, parent, prop, index);

          if (this.replacement) {
            node = this.replacement;
            this.replace(parent, prop, index, node);
          }

          if (this.should_remove) {
            this.remove(parent, prop, index);
          }

          var _removed = this.should_remove;
          this.replacement = _replacement2;
          this.should_remove = _should_remove2;
          if (_removed) return null;
        }
      }

      return node;
    }
  }]);

  return SyncWalker;
}(WalkerBase);